import { useEffect, useState } from 'react';
import { useWindowSize } from 'usehooks-ts';
const MOBILE_BREAKPOINT = 1024;
export function useIsMobile() {
  const {
    width
  } = useWindowSize();
  const clientIsMobile = width < MOBILE_BREAKPOINT;
  const [isMobile, setIsMobile] = useState(clientIsMobile);
  useEffect(() => {
    setIsMobile(clientIsMobile);
    global.isMobile = clientIsMobile;
  }, [clientIsMobile]);
  return isMobile;
}